import { mainSiteUrl } from '@/mocks/siteData';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20composition%20of%20trendy%20pastel%20sneakers%20lightweight%20denim%20jacket%20cotton%20tshirt%20and%20canvas%20tote%20bag%20arranged%20diagonally%20on%20textured%20oatmeal%20linen%20fabric%20surface%20with%20scattered%20eucalyptus%20leaves%2C%20bright%20morning%20sunlight%20casting%20soft%20angular%20shadows%2C%20high-end%20editorial%20product%20photography%20style%2C%20creamy%20warm%20offwhite%20background%20with%20subtle%20fabric%20weave%20texture%20visible%2C%20clean%20minimal%20composition%20with%20intentional%20negative%20space%2C%20contemporary%20lifestyle%20aesthetic&width=1800&height=1200&seq=hero-v2-march-26a&orientation=landscape"
          alt="Artistic fashion flatlay with sneakers and accessories"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-24">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
            Master Your
            <br />
            Purchases with
            <br />
            <span className="text-accent-300">Oopbuyspreadsheet</span> System
          </h1>

          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-xl leading-relaxed">
            The most advanced oopbuyspreadsheet tracking and cost management system for fashion buyers, sneaker resellers, and smart sourcing professionals.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Explore Oopbuyspreadsheet Guide
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Main Platform
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 py-8 md:py-12 overflow-hidden">
        <div className="whitespace-nowrap">
          <span className="font-heading text-6xl md:text-8xl lg:text-9xl font-extrabold text-white/8 tracking-wider select-none">
            OOPBUY SPREADSHEETS
          </span>
        </div>
      </div>
    </section>
  );
}